function load_layout_method_info(sender) {
    var $ = jQuery.noConflict();
    var elm = $(sender);
    elm.find('option[value="0"]').remove();

    var v = elm.val();

    var opt = elm.find('option[value="'+v+'"]');
    var info = JSON.parse(opt.attr('data-info'));

    var info_wrapper = elm.parents('.column').next();
    info_wrapper.html('<label>'+info.name+'</label>'+info.description);

    if (info.downloadUrl) {
        info_wrapper.append('<a href="' + info.downloadUrl + '">Download layout</a><br />');
    } else {
        info_wrapper.append('<a href="/print/preview/'+info.object+'/'+info.method+'">Download voorbeeld</a><br />');
    }
    if(info.variables) {
        info_wrapper.append('<b>Variabelen:</b><pre style="white-space: inherit;">'+info.variables+'</pre>');
    }
    info_wrapper.show();
}
function set_the_name(val, nameInput) {
    var v = val.split(/(\\|\/)/g).pop().split('.');
    var arr = [];
    delete v[v.length - 1];
    v.forEach(function(value) {
        if(value != undefined) {

            arr.push(value);
        }
    });
    nameInput.val(arr.join('.'));
}